import { render } from "./news.vue?vue&type=template&id=31add317&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=31add317&lang=scss&scoped=true"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31add317"]])

export default __exports__